/** @jsx jsx */
import { jsx } from '@emotion/core';

// This spinner is a copy of loading spinner from index.html file
// This spinner has inline styles already on index.html file
// Purpose: This spinner is present always and we dont have to wait
// for react-components LoadingSpinner component to be loaded
// Bug: If we use LoadingSpinner from react-components in app.tsx/LazyBilling
// or LazyLanding files, then react-components/LoadingSpinner has to be
// preloaded and ready to render. So this is a fallback until all the
// required components load, we show this default spinner
export const LoadingSpinnerFromIndexFile = (): JSX.Element => (
  <div className="init-spinner-container">
    <div className="init-spinner"></div>

    <svg
      width="33px"
      height="48px"
      viewBox="0 0 33 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Production-assets"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-171.000000, -269.000000)" id="Lock">
          <g transform="translate(163.000000, 268.000000)">
            <rect id="Rectangle-2" x="0" y="0" width="50" height="50"></rect>
            <path
              d="M25.2599,31.1042 L25.2599,36.9792"
              id="Stroke-1"
              stroke="#B4B4B4"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <g
              id="Group-6"
              transform="translate(9.000000, 1.500000)"
              stroke="#B4B4B4"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            >
              <path
                d="M31.1080271,21.209925 C31.1080271,20.2219458 30.2013188,19.4200083 29.0831104,19.4200083 L2.75919375,19.4200083 C1.64098542,19.4200083 0.734277083,20.2219458 0.734277083,21.209925 L0.734277083,44.4700292 C0.734277083,45.461925 1.64392292,46.2658208 2.76604792,46.2658208 L29.0831104,46.2658208 C30.2013188,46.2658208 31.1080271,45.5686542 31.1080271,44.5796958 L31.1080271,21.209925 L31.1080271,21.209925 Z"
                id="Stroke-2"
              ></path>
              <path
                d="M6.33354375,19.4203021 L6.33354375,9.83230208 C6.33354375,4.53696875 10.6262104,0.24528125 15.9215437,0.24528125 L15.9215437,0.24528125 C21.2158979,0.24528125 25.5085646,4.53696875 25.5085646,9.83230208 L25.5085646,19.4203021"
                id="Stroke-4"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
);
